import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetNotificationTemplates } from "src/app/store/notification-template/notification-temlate.action";

export function NotificationTemplatesResolver() {
    return inject(Store).dispatch(new GetNotificationTemplates());
}